export default "__VITE_ASSET__DnB9WqZZ__"